import { Grid } from '@mui/material'

import ContentfulImage, { ImageType } from '@ecm/ui/element/ContentfulImage'
import useSmallScreen from '@ecm/ui/hook/UseSmallScreen'

type AuthorPhotoProps = {
  alt: string
  big?: boolean
  src: string
}

const AuthorPhoto = ({ src, alt, big }: AuthorPhotoProps) => {
  const isSmallScreen = useSmallScreen()
  return (
    <Grid
      sx={{
        img: {
          borderRadius: '50%',
        },
        marginRight: '1em',
      }}
    >
      <ContentfulImage
        imageType={ImageType.NonResponsive}
        src={src}
        alt={alt}
        width={isSmallScreen ? 48 : big ? 80 : 48}
        height={isSmallScreen ? 48 : big ? 80 : 48}
        objectFit="cover"
        priority
      />
    </Grid>
  )
}

export default AuthorPhoto
